import React, {useContext, useState, useEffect} from 'react';
import { Container, Row } from 'react-bootstrap';
import { LabelText } from '../../Language';
import { LanguageContext } from "../../../containers/Language/LanguageProvider";
import { ChangeRequestContext } from "../../../ChangeRequest/context/ChangeRequestProvider";
import { CalendarChangeRequestContext } from "../../../ChangeRequest/context/CalendarChangeRequestProvider";
import { isValueNullOrUndefinedOrEmpty } from '../../../common/utility/utility';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { hiddenTooltip} from '../../../components/UI/Tooltip/Tooltip';
import {RemainingCharacters} from '../../../components/UI/RemainingCharacters/RemainingCharacters';
import config from '../../../common/const/config';
import './index.css';

function ChangeRequestDetails(props) {
    const sendTooltip = (
        <Tooltip id="sendButton">
          <LabelText tid="send" />
        </Tooltip>
      )

    const languageContext = useContext(LanguageContext);
    const { handlerOnActionButtonClick, handlerOnRemarksChange, handlerOnActionChange, handlerOnDownloadClick } = useContext(ChangeRequestContext);
    const [approverRemarks, setApproverRemarks] = useState(props.data.header.status > 1 ? 
                                                    props.data.header.approverRemarks : null);
    const [actionId, setActionId] = useState(props.data.header.status > 1 ? props.data.header.status : 1);   
    const { errorOrWarningHandler } = useContext(CalendarChangeRequestContext); 

    const getClassForStyling = (classValue, parent, fieldName) => {  
        return props.data[parent].oldValue[fieldName] != props.data[parent].newValue[fieldName] ? 
                                                        classValue + " highlight-change" : 
                                                        classValue;
    }

    const getRemarksValues = (optionId) => {        
        if(optionId && props.remarksOptions) 
        {      
            let optionValue = props.remarksOptions.filter(x => x.codeValueId === optionId);
            return <span>{languageContext.labels[optionValue[0].codeValue]}</span>  
        } 
    }   

    useEffect(() => {
        if(props.data && props.data.length > 0 && props.data.header.status > 1)
        {
            setApproverRemarks(props.data.header.approverRemarks);
            setActionId(props.data.header.status);
        }
    }, [props.data])


    const handlerOnActionClick = () => { 
        let isError = false;
        if (isValueNullOrUndefinedOrEmpty(approverRemarks)) {
            let remarksProperty = document.querySelectorAll(".approver-remarks-default");
            if (remarksProperty && remarksProperty.length > 0) {
                remarksProperty.forEach(element => {
                    element.setAttribute("style", "border:0.2vw; border-style:solid; border-color:red");
                });
            }
            isError = true;
        }
        if(actionId && actionId <= 1)
        {
            let actionProperty = document.querySelectorAll(".Change-request-details-select-box");
            if (actionProperty && actionProperty.length > 0) {
                actionProperty.forEach(element => {                   
                    element.setAttribute("style", "border:0.2vw; border-style:solid; border-color:red");
                });
            }
            isError = true;
        }
        if(isError === true)
        {
            errorOrWarningHandler(true, "all_mandatory", true, "change_request_action");  
        }
        else
        {
            handlerOnActionButtonClick(props.data.header.changeRequestNumber, approverRemarks, actionId
                , props.filterData, props.setFilterData); 
        }
    }

    const handlerOnApproverRemarksEnter = (remarks) => {
        let remarksProperty = document.querySelectorAll(".approver-remarks-default");
        if (remarksProperty && remarksProperty.length > 0) {
            remarksProperty.forEach(element => {
                element.setAttribute("style", "border:0.1vw; border-style:solid; border-color:#707070");
            });
        }

        setApproverRemarks(remarks.target.value);

        handlerOnRemarksChange(props.data.header.changeRequestNumber, remarks.target.value);
    }

    const handlerOnActionDropdownChange = (action) => { 
        let actionProperty = document.querySelectorAll(".Change-request-details-select-box");
        if (actionProperty && actionProperty.length > 0) {
            actionProperty.forEach(element => {
                element.setAttribute("style", "border:0.1vw; border-style:solid; border-color:#707070");
            });
        }

        setActionId(action.target.value);

        handlerOnActionChange(props.data.header.changeRequestNumber, action.target.value);
    } 

    const handlerOnDownloadFileClick = (isRevisedFile) => { 
            handlerOnDownloadClick(props.data.header.contractCode, props.data.header.revenueDate, isRevisedFile,
                isRevisedFile === false ? props.data.intakeBook.oldValue.userIntakeBookFileName : 
                props.data.intakeBook.newValue.userIntakeBookFileName
            );
        } 

    const actionList = () => {
        return (
                <select className="Change-request-details-select-box" 
                    disabled = {props.data.header.status > 1 ? true : false}
                    onChange = {(e)=> handlerOnActionDropdownChange(e)} 
                    value = {actionId}
                >
                    <option value = "1" style={{display:"none"}} />                               
                    <option value = "2" >{languageContext.labels[props.data.header.status > 1 ? "status_approved":  "status_approve"]}</option>
                    <option value = "3" >{languageContext.labels[props.data.header.status > 1 ? "status_declined" : "status_decline"]}</option>
                </select>
        );
    }

    const actionButton = () => {
        return (
        <OverlayTrigger  placement="right" overlay={props.data.header.status === 1 ? sendTooltip: hiddenTooltip}>
            <div role= {props.data.header.status < 1 || props.data.header.status > 1 ? undefined : "button"} 
                tabIndex={props.data.header.status === 1 ? 0 : -1}
                className = { 
                    props.data.header.status === 1 ? "Change-request-action-icon" : "Change-request-action-icon-disabled"
                }
                disabled = {props.data.header.status < 1 || props.data.header.status > 1} 
                onClick={(ev)=>props.data.header.status === 1 && handlerOnActionClick()}
                onKeyDown={(ev)=>{ if (ev.key === "Enter" && props.data.header.status === 1) handlerOnActionClick()}} 
            />
        </OverlayTrigger>);
    }

    const intakeBookCrCounter = (headerColSpan, counterTitleColSpan, counterColSpan) => {
        return (
            <>
                <td colspan = {headerColSpan} className="text-header"></td>                        
                <td colspan = {counterTitleColSpan} className="input-box-td-style" style={{textAlign:"right"}}>
                    <span className="Change-request-details-label">
                        {props.data.intakeBook && <LabelText tid="change_counter" />}
                    </span>
                </td>
                <td colspan = {counterColSpan}  className="input-box-td-style" style={{textAlign:"left"}}>                               
                    &nbsp;&nbsp;<span className="Change-request-details-label">
                        {props.data.intakeBook && props.data.header.changeCounter}
                    </span>
                </td> 
            </>
        )
    }

    const revenueCrCounter = (emptyColSpan, counterLabelColSpan, counterColSpan) => {
        return (
            <>
                <td colspan={emptyColSpan} className="input-box-td-style"></td>
                <td colspan={counterLabelColSpan} className="input-box-td-style" style={{textAlign:"right"}}>
                    <span className="Change-request-details-label">
                    <LabelText tid="change_counter" /></span>
                </td>
                <td colspan={counterColSpan} className="input-box-td-style" style={{textAlign:"left"}}>                               
                    &nbsp;&nbsp;<span className="Change-request-details-label">{props.data.header.changeCounter}</span>
                </td>
            </>
        )
    }

    return (
        props.data.revenue ? <Container className="Cr-overview-container">
            <Row>
                <table className="Change-request-revenue-table col-xs-12">
                    <thead>
                        <tr>    
                            <th colspan= "3" className="label-header"></th>                       
                            <th colspan= "1" className="submitted-date-header"><LabelText tid="SubmittedDateTime" /></th>
                            <th colspan= "1" className="shop-open-header"><LabelText tid="Shop_Open" /></th>
                            <th colspan= "2" className="remarks-header align-text-left"><LabelText tid="shop_open_remarks" /></th>
                            <th colspan= "1" className="vat0-header">
                                <div><LabelText tid="taxed0" /></div><div><LabelText tid="withvat" /></div></th>
                            <th colspan= "1" className="vat6-header"> 
                                <div><LabelText tid="taxed6" /></div><div><LabelText tid="withvat" /></div></th>
                            <th colspan= "1" className="vat12-header">
                                <div><LabelText tid="taxed12" /></div><div><LabelText tid="withvat" /></div></th>
                            <th colspan= "1" className="vat21-header">
                                <div><LabelText tid="taxed21" /></div><div><LabelText tid="withvat" /></div></th>
                            <th colspan= "1" className="sold-tickets-header"><LabelText tid="Sold_Ticket" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>  
                            <td colspan= "3" className="label-value inner-table-text-align"><LabelText tid="old_revenue_value"/></td>                                  
                            <td colspan= "1" className="submitted-date">{props.data.revenue.oldValue.submittedDateTime}</td>
                            <td colspan= "1" className={getClassForStyling("shop-open", "revenue", "isShopOpen")}>{languageContext.labels[props.data.revenue.oldValue.isShopOpen.toLowerCase()]}</td>
                            <td colspan= "2" className={getClassForStyling("remarks align-text-left", "revenue", "remarksId")}>{getRemarksValues(props.data.revenue.oldValue.remarksId)}</td>
                            <td colspan= "1" className={getClassForStyling("vat0 align-text-right", "revenue", "tax_0")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.oldValue.tax_0) && props.data.revenue.oldValue.tax_0.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("vat6 align-text-right", "revenue", "tax_6")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.oldValue.tax_6)  && props.data.revenue.oldValue.tax_6.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("vat12 align-text-right", "revenue", "tax_12")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.oldValue.tax_12)  && props.data.revenue.oldValue.tax_12.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("vat21 align-text-right", "revenue", "tax_21")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.oldValue.tax_21)  && props.data.revenue.oldValue.tax_21.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("sold-tickets align-text-right", "revenue", "soldTicket")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.oldValue.soldTicket) && props.data.revenue.oldValue.soldTicket.toLocaleString('nl-BE')}</td>                                    
                        </tr>  
                        <tr>   
                            <td colspan= "3" className="inner-table-text-align"><LabelText tid="new_revenue_value"/></td>                                  
                            <td colspan= "1" >{props.data.revenue.newValue.submittedDateTime}</td>
                            <td colspan= "1" className={getClassForStyling("", "revenue", "isShopOpen")}>{languageContext.labels[props.data.revenue.newValue.isShopOpen.toLowerCase()]}</td>
                            <td colspan= "2" className={getClassForStyling("align-text-left", "revenue", "remarksId")}>{getRemarksValues(props.data.revenue.newValue.remarksId)}</td>
                            <td colspan= "1" className={getClassForStyling("align-text-right", "revenue", "tax_0")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.newValue.tax_0)  && props.data.revenue.newValue.tax_0.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("align-text-right", "revenue", "tax_6")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.newValue.tax_6)  && props.data.revenue.newValue.tax_6.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("align-text-right", "revenue", "tax_12")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.newValue.tax_12)  && props.data.revenue.newValue.tax_12.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("align-text-right", "revenue", "tax_21")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.newValue.tax_21)  && props.data.revenue.newValue.tax_21.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td colspan= "1" className={getClassForStyling("align-text-right", "revenue", "soldTicket")}>{!isValueNullOrUndefinedOrEmpty(props.data.revenue.newValue.soldTicket)  && props.data.revenue.newValue.soldTicket.toLocaleString('nl-BE')}</td>                                    
                        </tr>   
                        <tr>
                            <td colspan="1" className="bp-remarks inner-table-text-align"><LabelText tid="remarks_business_partner"/></td>
                            <td colspan="11" className="input-box-td-style">
                               <div className="remarks-value disable-action">{props.data.header.businessPartnerRemarks}</div>
                            </td>
                        </tr>
                        <tr>  
                            <td colspan="1" className="approver-remarks inner-table-text-align"><LabelText tid="approver_remarks" /></td>                                    
                            <td colspan="11" className="input-box-td-style">
                                <input type="text" maxLength={config.maxCharLengthOfRemarks}
                                    placeholder={props.isNmbsUser && props.data.header.status === 1 ? languageContext && languageContext.labels["allowed_chars"] : undefined}
                                    className= {!props.isNmbsUser || props.data.header.status > 1 ? 
                                                "remarks-value disable-action" : approverRemarks 
                                                && approverRemarks.length > 0 ? 
                                                "approver-remarks-default approver-remarks-value" : 
                                                "approver-remarks-default"}
                                    onChange = {!props.isNmbsUser || props.data.header.status > 1 ? 
                                                    undefined : (e) => handlerOnApproverRemarksEnter(e)} 
                                    disabled = {!props.isNmbsUser || props.data.header.status > 1 ? true : false}  
                                                value = {approverRemarks} />
                                {
                                    props.isNmbsUser && props.data.header.status === 1 && approverRemarks && approverRemarks.length > 0 ?
                                    <RemainingCharacters enteredCharsLength={approverRemarks.length} />
                                    : undefined
                                }
                            </td>
                        </tr> 
                        {props.isNmbsUser && props.isEditAccess ? <tr> 
                            <td colspan= "2" className="inner-table-text-align" 
                                style={{paddingTop: "0.5vw"}}>
                                <LabelText tid="actions" />
                            </td>                            
                            <td className="input-box-td-style" colspan="3" >
                                {actionList()}
                            </td>
                            <td className="input-box-td-style" colspan= "1">
                                {actionButton()}
                            </td>
                            {revenueCrCounter("3", "2", "1")}
                        </tr> 
                        : <tr>
                            {revenueCrCounter("8", "3", "1")}
                        </tr> 
                    }                                           
                    </tbody>
                </table>                                           
            </Row>           
        </Container> :
        props.data.intakeBook || props.data.unblock ?  <Container className="Cr-overview-container">
            <Row>
                <table className="Change-request-intake-table">
                    <thead>
                        <tr> 
                            <th colspan="2" className="text-header"></th>                           
                            <th colspan="10" className="value-header"></th>                                                 
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan = "2" style={{width: "20%"}} className="inner-table-text-align">
                                { 
                                    props.data.intakeBook ? <LabelText tid="old_daily_receipts_journal" />
                                    : props.data.unblock ? <LabelText tid="unblock_start_date" />: null
                                }
                            </td>
                            <td colspan = "1"  style={{width: "20%"}} className="input-box-td-style">
                                <div className="intake-book-value"> 
                                    {   props.data.intakeBook ? 
                                            <input type="button" className="link-text-style" 
                                            value= {languageContext.labels["Link"]}
                                            onClick = { () => handlerOnDownloadFileClick(false) } 
                                            /> 
                                        :   props.data.unblock ? <div className="unlock-date-text-style">
                                                                    { props.data.unblock.unblockStartDate } 
                                                                </div>
                                        :   null
                                    }     
                                </div> 
                            </td>                           
                            <td colspan = "9"  style={{width: "60%"}} className="input-box-td-style"></td>
                        </tr> 
                        <tr>  
                            <td colspan = "2"  style={{width: "20%"}} className="inner-table-text-align">
                                { 
                                    props.data.intakeBook ? <LabelText tid="new_daily_receipts_journal" />
                                    : props.data.unblock ? <LabelText tid="unblock_end_date" />: null
                                }
                            </td>                                    
                            {props.data.intakeBook &&  <td colspan = "1"  style={{width: "20%"}} className="input-box-td-style">
                                <div className="intake-book-value"> 
                                    <input type="button" className="link-text-style" 
                                            value= {languageContext.labels["Link"]}
                                            onClick = { () => handlerOnDownloadFileClick(true) }
                                    />
                                </div>
                            </td>}
                            {props.data.unblock && <td colspan = "1"  style={{width: "20%"}} className="input-box-td-style">
                                <div className={props.isNmbsUser ? "unlock-end-date" : "intake-book-value"}>
                                    <div className={!props.isNmbsUser ? "unlock-date-text-style" : "unlock-end-date-text"}>{ props.data.unblock.unblockEndDate }</div>
                                </div>
                                {props.isNmbsUser && <div className={"unlock-end-date-upto"}>
                                   <div className="unlock-end-date-upto-text">+{props.data.unblock.unblockValidtillDays} <LabelText tid="unblock_end_date_upto" /></div>
                                </div>}
                            </td>}
                            <td colspan = "9" style={{width: "60%"}} className="input-box-td-style"></td>
                        </tr>  
                        <tr>
                            <td colspan = "2"  style={{width: "20%"}} className="bp-remarks inner-table-text-align">
                                <LabelText tid="remarks_business_partner" />
                            </td>
                            <td colspan = "7"  style={{width: "75%"}} className="input-box-td-style">
                                <div className="remarks-value disable-action">{ props.data.header.businessPartnerRemarks }</div>
                            </td>                           
                            <td colspan = "3" style={{width: "5%"}} className="input-box-td-style"></td>
                        </tr>
                        <tr>
                            <td colspan = "2" style={{width: "20%"}} className="approver-remarks inner-table-text-align">
                                <LabelText tid="approver_remarks" />
                            </td>                                    
                            <td colspan = "7" style={{width: "75%"}} 
                                className="input-box-td-style">
                                <input  type="text" maxLength={config.maxCharLengthOfRemarks} 
                                        placeholder={props.isNmbsUser && props.data.header.status === 1 ? 
                                                    languageContext && languageContext.labels["allowed_chars"] : undefined}
                                        className= {!props.isNmbsUser || props.data.header.status > 1 ? 
                                                    "approver-remarks-default disable-action": 
                                                    approverRemarks && approverRemarks.length > 0 ? 
                                                    "approver-remarks-default approver-remarks-value" : 
                                                    "approver-remarks-default"} 
                                        onChange = { !props.isNmbsUser || props.data.header.status > 1 ? undefined : (e) => handlerOnApproverRemarksEnter(e)} 
                                        disabled = { !props.isNmbsUser || props.data.header.status > 1 ? true : false}  
                                        value = {approverRemarks}   
                                />
                                {
                                    props.isNmbsUser && props.data.header.status === 1 && 
                                    approverRemarks && approverRemarks.length > 0 &&
                                    <RemainingCharacters enteredCharsLength={approverRemarks.length} />
                                }
                            </td> 
                            <td colspan = "3" style={{width: "5%"}} className="input-box-td-style"></td>
                        </tr>
                        {props.isNmbsUser && props.isEditAccess ? <tr> 
                            <td colspan = "2" className="inner-table-text-align">
                                <LabelText tid="actions" />
                            </td>                            
                            <td className="input-box-td-style" colspan = "1" >
                                {actionList() }
                            </td>
                            <td className="input-box-td-style" colspan = "1" >
                                {actionButton() }
                            </td>    
                            {intakeBookCrCounter("2", "2", "4")}                                          
                        </tr> :
                        props.data.intakeBook ? <tr>
                            {intakeBookCrCounter("5", "3", "4")}
                        </tr>
                        : props.data.unblock && props.data.header 
                        && props.data.header.submittedDateTime
                        && props.data.header.status === 2 && <tr>
                            <td colspan="2"  style={{width: "20%"}} className="inner-table-text-align" />
                            <td colspan="7" className="input-box-td-style unlock-valid-date-upto-text">
                                <LabelText tid="revenue_unblock_period" />&nbsp;{props.data.header.submittedDateTime.split(' ')[0]} - {props.data.unblock.unblockValidtillDate}
                            </td>
                            <td colspan="3" className="text-header"></td>   
                        </tr>
                    }
                    </tbody>
                </table>               
            </Row>            
        </Container> : null
    );
}    

export default ChangeRequestDetails;
